import React from 'react';

interface IVignetteSLOProps {
	size?: string;
	category?: string;
	className?: string;
}

export const VignetteSLO = ({ className, category, size = '72' }: IVignetteSLOProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} className={className} viewBox="0 0 72 72" fill="none">
			<rect width="72" height="72" rx="8" fill="#F4F4F4" />
			<path
				d="M11.25 22.5C11.25 19.6504 11.2516 17.5886 11.463 16.0163C11.6715 14.4656 12.0716 13.5038 12.7877 12.7877C13.5038 12.0716 14.4656 11.6715 16.0163 11.463C17.5886 11.2516 19.6504 11.25 22.5 11.25H49.5C52.3496 11.25 54.4114 11.2516 55.9837 11.463C57.5344 11.6715 58.4962 12.0716 59.2123 12.7877C59.9284 13.5038 60.3285 14.4656 60.537 16.0163C60.7484 17.5886 60.75 19.6504 60.75 22.5V49.5C60.75 52.3496 60.7484 54.4114 60.537 55.9837C60.3285 57.5344 59.9284 58.4962 59.2123 59.2123C58.4962 59.9284 57.5344 60.3285 55.9837 60.537C54.4114 60.7484 52.3496 60.75 49.5 60.75H22.5C19.6504 60.75 17.5886 60.7484 16.0163 60.537C14.4656 60.3285 13.5038 59.9284 12.7877 59.2123C12.0716 58.4962 11.6715 57.5344 11.463 55.9837C11.2516 54.4114 11.25 52.3496 11.25 49.5V22.5Z"
				fill="white"
				stroke="#707070"
				strokeWidth="1.5"
			/>
			<rect x="14.25" y="14.25" width="43.5" height="43.5" rx="2.25" fill="#F4F4F4" />
			<path
				d="M36 54C45.9411 54 54 45.9411 54 36C54 26.0589 45.9411 18 36 18C26.0589 18 18 26.0589 18 36C18 45.9411 26.0589 54 36 54Z"
				fill="white"
			/>
			<path d="M31.7576 17.2484L35.1515 16.5V56.1666L24.9697 51.2083L31.7576 17.2484Z" fill="#F4F4F4" />
			<path d="M40.2424 16.8742L36.8485 16.5V56.1666L47.0303 51.659L40.2424 16.8742Z" fill="#F4F4F4" />
			<path d="M3 60.75H64.5" stroke="#707070" strokeWidth="1.5" />
			<path d="M66.75 60.75L69 60.75" stroke="#707070" strokeWidth="1.5" />
			{category === '1' ? (
				<path d="M55 0H64C68.4183 0 72 3.58172 72 8V17H55V0Z" fill="#ffcc00" />
			) : (
				<path d="M46 0H64C68.4183 0 72 3.58172 72 8V17H46V0Z" fill="#ffcc00" />
			)}
			{category === '2B' && (
				<path
					d="M52.408 12H57.34V10.752H55.18C54.928 10.752 54.712 10.752 54.436 10.776C56.14 9.264 57.268 8.268 57.268 6.708C57.268 5.196 56.236 4.428 54.712 4.428C53.848 4.428 53.14 4.644 52.672 4.872V6.132C53.068 5.928 53.692 5.712 54.316 5.712C55.084 5.712 55.576 6.036 55.576 6.828C55.576 8.076 54.64 8.928 52.408 10.956V12ZM59.0239 12H61.9399C63.5599 12 64.5919 11.196 64.5919 9.828C64.5919 8.856 63.9919 8.292 63.1879 8.112V8.088C63.7999 7.92 64.3639 7.356 64.3639 6.432C64.3639 5.292 63.4879 4.524 61.8679 4.524H59.0239V12ZM60.6679 10.716V8.7H61.6999C62.4439 8.7 62.8159 9.048 62.8159 9.72C62.8159 10.38 62.4199 10.716 61.6879 10.716H60.6679ZM60.6679 7.572V5.808H61.6639C62.3839 5.808 62.7079 6.144 62.7079 6.66C62.7079 7.236 62.3959 7.572 61.6519 7.572H60.6679Z"
					fill="#121212"
				/>
			)}
			{category === '2A' && (
				<path
					d="M52.408 12H57.34V10.752H55.18C54.928 10.752 54.712 10.752 54.436 10.776C56.14 9.264 57.268 8.268 57.268 6.708C57.268 5.196 56.236 4.428 54.712 4.428C53.848 4.428 53.14 4.644 52.672 4.872V6.132C53.068 5.928 53.692 5.712 54.316 5.712C55.084 5.712 55.576 6.036 55.576 6.828C55.576 8.076 54.64 8.928 52.408 10.956V12ZM60.8239 9.192L61.4719 7.272C61.6159 6.84 61.7599 6.384 61.8559 6.048H61.8799C61.9639 6.396 62.1079 6.828 62.2519 7.272L62.8759 9.192H60.8239ZM58.1959 12H59.8879L60.3919 10.512H63.3079L63.7879 12H65.5759L62.8399 4.524H61.0039L58.1959 12Z"
					fill="#121212"
				/>
			)}
			{category === '1' && (
				<path
					d="M62.836 12H64.468V4.524H63.184C62.728 4.836 61.852 5.16 61.276 5.244V6.504C61.684 6.432 62.452 6.24 62.836 6.024V12Z"
					fill="#121212"
				/>
			)}
			<circle cx="36" cy="36" r="18.75" stroke="#A3A3A3" strokeWidth="1.5" />
			<path
				d="M36 24C32.7 24 29.75 25 28.875 25.5L25.5 31.5C27.75 31.125 31.875 30.375 36 30.375C40.125 30.375 44 31.125 46.5 31.5L42.75 25.5C41.75 25 39.3 24 36 24Z"
				stroke="#A3A3A3"
				strokeWidth="1.5"
			/>
			<circle cx="27.375" cy="36.375" r="1.875" stroke="#A3A3A3" strokeWidth="1.5" />
			<circle cx="43.875" cy="36.375" r="1.875" stroke="#A3A3A3" strokeWidth="1.5" />
			<path d="M49.5 36L48 41.25" stroke="#A3A3A3" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M21.75 36L23.25 41.25" stroke="#A3A3A3" strokeWidth="1.5" strokeLinecap="square" />
			<path d="M25.5 44.25L30 44.25" stroke="#A3A3A3" strokeWidth="2.25" strokeLinecap="square" />
			<path d="M42 44.25L46.5 44.25" stroke="#A3A3A3" strokeWidth="2.25" strokeLinecap="square" />
			<path
				d="M30.75 39.75C31.5 40 33.525 40.5 35.625 40.5C37.725 40.5 39.75 40 40.5 39.75"
				stroke="#A3A3A3"
				strokeWidth="1.5"
				strokeLinecap="square"
			/>
		</svg>
	);
};
